var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-list',{attrs:{"loading-count":_vm.loadingCount,"sort-by":"-isAvailable price","items":_vm.value},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('box',{key:item._id,attrs:{"value":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }